import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import './Services.css';

// Dynamic images for each service
import img1 from '../assets/accounting-big.png';
import img2 from '../assets/tax.png';
import img3 from '../assets/wealth.png';
import img4 from '../assets/credit-card.png';
import img5 from '../assets/business-advisory.png';
import img6 from '../assets/data-analytics.png';

const servicesData = [
  {
    id: 'accounting-financial-reporting',
    title: 'Accounting and Financial Reporting',
    description: `At Tax o Wealth, our expert team is dedicated to ensuring that your business maintains accurate and comprehensive financial records. We understand the importance of reliable data in making informed decisions and maintaining compliance with regulatory standards. Our services are designed to support your business at every financial cycle stage, providing clear, consistent, and audit-ready reports that reflect your true financial status.

Our professionals are skilled in a range of financial disciplines and utilize the latest accounting software and methodologies. This blend of expertise and technology ensures that our financial reporting is not only compliant with current accounting standards but also strategically insightful, helping you understand the underlying trends and opportunities within your financial data.`,
    image: img1,
  },
  {
    id: 'tax-planning-compliance',
    title: 'Tax Planning and Compliance',
    description: `At Tax o Wealth, we recognize the complexities of tax management and strive to provide our clients with optimized tax solutions that enhance their financial efficiency and compliance. Our team of tax experts specializes in navigating the intricate world of taxes, ensuring that your obligations are met and your opportunities maximized. We offer a full suite of tax services, from planning and compliance to representation and dispute resolution, tailored to the unique needs of both individuals and businesses. 

    Our approach involves proactive strategies that anticipate tax implications and align them with your business objectives. We stay abreast of the latest tax regulations and changes to provide timely and authoritative advice. By integrating our tax planning with your overall financial goals, we help minimize liabilities and maximize compliance, thereby reducing your tax burden while supporting your financial success.`,
    image: img2,
  },
  {
    id: 'wealth-investment-management',
    title: 'Wealth and Investment Management',
    description: `At Tax o Wealth, we understand that effective wealth and investment management is critical to achieving and maintaining long-term financial security. Our tailored services are designed to address the unique needs of each client, whether they are individuals, families, or businesses. By combining personalized advice, robust financial strategies, and continuous portfolio oversight, we help our clients navigate the complexities of wealth management and achieve their financial goals. 

    Our team of experienced advisors is committed to building and maintaining trust through transparent and informed guidance. We employ a holistic approach that encompasses all aspects of wealth management, from investment selection to estate planning, ensuring that every facet of your financial future is secure. With Tax o Wealth, you gain a partner who is dedicated to your long-term success and peace of mind.`,
    image: img3,
  },
  {
    id: 'loan-credit-card',
    title: 'Loan & Credit Card',
    description: `At Tax o Wealth, we take pride in offering a comprehensive suite of loan and credit card services to cater to the diverse financial needs of our valued clients. With our extensive network of partner banks and NBFCs, we bring you a wide range of borrowing options coupled with personalized assistance and expert guidance every step of the way.

    At Tax o Wealth, we understand that financial needs vary from person to person and from one stage of life to another. That's why we're proud to offer a comprehensive suite of loan and credit card services designed to cater to the diverse needs of our clients. Whether you're looking to purchase a home, fund your child's education, expand your business, or simply need a convenient way to manage your day-to-day expenses, we have the expertise and resources to help you find the right borrowing solutions tailored to your unique circumstances.`,
    image: img4,
  },
  {
    id: 'business-advisory-consulting',
    title: 'Business Advisory and Consulting',
    description: `At Tax o Wealth, we offer strategic business advisory and consulting services aimed at guiding our clients through every stage of their business journey. Whether you are a startup looking to establish your presence or an established corporation seeking to optimize your operations, our expert advisors are here to help. Our comprehensive suite of services encompasses everything from business formation and financial planning to mergers and acquisitions advisory and corporate governance. 
  
    We understand that every business is unique, which is why we tailor our advisory services to meet the specific needs and goals of each client. Our team brings a wealth of industry experience and expertise to the table, providing insightful guidance and practical solutions that drive growth, enhance efficiency, and maximize profitability. With Tax o Wealth as your trusted advisor, you can navigate the complexities of the business landscape with confidence..`,
    image: img5,
  },
  {
    id: 'data-analytics-reporting',
    title: 'Data Analytics and Reporting',
    description: `At Tax o Wealth, we understand the importance of data-driven insights in making informed business decisions and driving organizational success. Our Data Analytics and Reporting services are designed to empower businesses with the tools and knowledge needed to unlock the full potential of their data. From data analysis and interpretation to predictive analytics solutions and big data implementation, we offer a comprehensive suite of services tailored to meet the unique needs of each client. 

    Our team of experienced data analysts and reporting specialists leverages advanced analytics tools and methodologies to extract actionable insights from complex datasets. Whether you are looking to optimize financial performance, improve operational efficiency, or enhance customer satisfaction, our Data Analytics and Reporting services can help you achieve your business objectives with confidence.`,
    image: img6,
  },
];

const Services = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const serviceSections = document.querySelectorAll('.service-section');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    serviceSections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="services-page">    
    <div className="breadcrumb-container">
        <p>
          <a href="/">Home</a> / Services
        </p>
      </div>
      <h2 className="main-title">BEST CLIENT SERVICES</h2>
      <p className="intro-text">
        We understand that merely having a rich product basket is not enough for our valued clients. 
        What clients really need is a holistic platform for an entire family (or an organization) to record, report & manage a 
        comprehensive portfolio of holdings into multiple financial products.
      </p>

      <div className="services-container">
        {servicesData.map((service, index) => (
          <div key={service.id} className={`service-section ${index % 2 === 0 ? 'reverse' : ''}`}>
            <div className="service-image">
              <img src={service.image} alt={service.title} />
            </div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p className="service-text">{service.description}</p>
              <button onClick={() => navigate(`/services/${service.id}`)}>KNOW MORE</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
